
function Footer(){
    return(
        <div className="min-w-screen flex justify-center py-8 border-t-[7px] border-gray-300 bg-red-500">
            <p className="max-w-[60%] text-white font-light lg:text-[14px] md:text-[13px] sm:text-[12px] font-lato sm:max-w-[90%] text-center">
                This User Interface is not to be reproduced, copied or used in any form or manner without the consent, approval and knowledge of the Owner. 
            </p>
        </div>
    )
}

export default Footer;